import { render, staticRenderFns } from "./ProductDescription.vue?vue&type=template&id=2dd1ff41"
import script from "./ProductDescription.vue?vue&type=script&lang=js"
export * from "./ProductDescription.vue?vue&type=script&lang=js"
import style0 from "./ProductDescription.vue?vue&type=style&index=0&id=2dd1ff41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports